
export function useUrlValidation() {
  const validateTikTokUrl = (inputUrl: string): boolean => {
    if (!inputUrl.includes('tiktok.com')) {
      return false;
    }
    
    // Desktop collection URL pattern
    const collectionRegex = /tiktok\.com\/@[^\/]+\/collection\/([^\/\?&#]+)/;
    // Mobile short URL pattern (both vm.tiktok.com and vt.tiktok.com)
    const mobileRegex = /(?:vm|vt)\.tiktok\.com\/[A-Za-z0-9]+\/?/;
    // Mobile web URL pattern
    const mobileWebRegex = /tiktok\.com\/t\/[A-Za-z0-9]+\/?/;
    
    return collectionRegex.test(inputUrl) || mobileRegex.test(inputUrl) || mobileWebRegex.test(inputUrl);
  };

  return { validateTikTokUrl };
}
